/* istanbul ignore file */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { breakpoints } from 'app/shared/styles_js/variables';

import { useKeyDownToggler } from '../../../hooks/useKeyDownToggler';
import { GridRowSt, GridColSt } from '../Grid.css';

import { GridOverlaySt, GridContainerDebugSt } from '.';

// a grid debugger - dev only - css is used to style grid in dashboard
const GridDebugger = ({ fluidBreakpoints }) => {
  const gridToggled = useKeyDownToggler('g');
  const darkMode = useKeyDownToggler('d');
  const invert = useKeyDownToggler('F19');
  useEffect(() => {
    if (darkMode) {
      document.body.style.background = '#000';
    } else {
      document.body.style.background = 'inherit';
    }
  }, [darkMode]);

  useEffect(() => {
    if (invert) {
      document.body.style.filter = 'invert(1)';
    } else {
      document.body.style.filter = 'inherit';
    }
  }, [invert]);
  if (!gridToggled) {
    return <></>;
  }
  return (
    <GridOverlaySt>
      <GridContainerDebugSt fluidBreakpoints={fluidBreakpoints}>
        <GridRowSt>
          {[...new Array(12).keys()].map(x => (
            <GridColSt key={`debug-${x}`} sm={1} className="debug-col-1">
              <div />
            </GridColSt>
          ))}
        </GridRowSt>
      </GridContainerDebugSt>
    </GridOverlaySt>
  );
};

GridDebugger.propTypes = {
  fluidBreakpoints: PropTypes.arrayOf(
    PropTypes.oneOf(Object.keys(breakpoints)),
  ),
};

GridDebugger.defaultProps = {
  fluidBreakpoints: [],
};

export default GridDebugger;
